<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">Global Header</h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<maced-global-header globalHeaderId="globalHeader1"  [title]="title" [subTitle]="subTitle" [backUrl]="backUrl"
  [logoUrl]="logoUrl" [logo]="logo" [smallLogo]="smallLogo" [logoAltText]="logoAltText" [moreMenuTitle]="moreMenuTitle"
  [ariaLabels]="ariaLabels" [hasBackButtonDisabled]="true" [isSingleAction]="true">
  <ng-container ngProjectAs="[actions]">
    <maced-button size="large" buttonId="submit" label="Test" buttonType="submit"></maced-button>
  </ng-container>
</maced-global-header>
<br>
<maced-global-header globalHeaderId="globalHeader2"  [title]="title" [subTitle]="subTitle" [logoUrl]="logoUrl"
  [logo]="logo" [smallLogo]="smallLogo" [logoAltText]="logoAltText" [moreMenuTitle]="moreMenuTitle"
  [ariaLabels]="ariaLabels" [hasReversedTitle]="true" [isSingleAction]="true">
  <ng-container ngProjectAs="[actions]">
    <maced-button size="large" type="link" color="primary" [url]="callToAction" buttonId="submit12"
      label="Call to Action">
    </maced-button>
  </ng-container>
</maced-global-header>
<br>
<maced-global-header globalHeaderId="globalHeader3"  [title]="title" [subTitle]="subTitle" [backUrl]="backUrl"
  [logoUrl]="logoUrl" [logoAltText]="logoAltText" [moreMenuTitle]="moreMenuTitle" [ariaLabels]="ariaLabels">
</maced-global-header>
<br>
<maced-global-header globalHeaderId="globalHeader4"  [title]="title" [backUrl]="backUrl" [logoUrl]="logoUrl"
  [logoAltText]="logoAltText" [moreMenuTitle]="moreMenuTitle" [ariaLabels]="ariaLabels">
</maced-global-header>
<br>
<maced-global-header globalHeaderId="globalHeader5"  [title]="title" [logoUrl]="logoUrl" [logoAltText]="logoAltText"
  [moreMenuTitle]="moreMenuTitle" [ariaLabels]="ariaLabels">
</maced-global-header>
<br>
<maced-global-header globalHeaderId="globalHeader6"  [title]="titleSpanish" [subTitle]="subTitleSpanish"
  [backUrl]="backUrl" [logoUrl]="logoUrl" [logo]="logo" [smallLogo]="smallLogo" [logoAltText]="logoAltTextSpanish"
  [moreMenuTitle]="moreMenuTitleSpanish" [ariaLabels]="ariaLabels">
</maced-global-header>
<br>
<maced-global-header globalHeaderId="globalHeader7"  [title]="titleHindi" [subTitle]="subTitleHindi" [backUrl]="backUrl"
  [logoUrl]="logoUrl" [logo]="logo" [smallLogo]="smallLogo" [logoAltText]="logoAltTextHindi"
  [moreMenuTitle]="moreMenuTitleHindi" [ariaLabels]="ariaLabels">
</maced-global-header>
<br>
<maced-global-header globalHeaderId="globalHeader8"  [title]="title" [subTitle]="subTitle" [backUrl]="backUrl"
  [logoUrl]="logoUrl" [logo]="logo" [smallLogo]="smallLogo" [logoAltText]="logoAltText" [moreMenuTitle]="moreMenuTitle"
  [ariaLabels]="ariaLabels">
</maced-global-header>
<br>
<maced-global-header globalHeaderId="globalHeader9"  [title]="title" [logoUrl]="logoUrl" [logo]="logo"
  [smallLogo]="smallLogo" [logoAltText]="logoAltText" [moreMenuTitle]="moreMenuTitle" [ariaLabels]="ariaLabels"
  [hasReversedTitle]="true" [isSingleAction]="false">
  <ng-container ngProjectAs="[actions]">
    <ul class="c-headers__list">
      <li class="c-headers__list-item">
        <maced-dropdown dropdownId="dropdownId0" name="dropdownId" ariaLabel="Dropdown" label="Select"
          cheveronClass="icon-chevron-down" [hasCheckboxesDropdown]="false" [options]="options"
          [selectedOption]="selectedOptions">
        </maced-dropdown>
      </li>
      <li class="c-headers__list-item">
        <maced-button size="large" type="link" color="primary" [url]="callToAction" buttonId="submit3"
          label="Call to Action"></maced-button>
      </li>
    </ul>
  </ng-container>
</maced-global-header>
<br>
<maced-global-header globalHeaderId="globalHeader10"  [title]="title" [subTitle]="subTitle" [backUrl]="backUrl"
  [logoUrl]="logoUrl" [logoAltText]="logoAltText" [moreMenuTitle]="moreMenuTitle" [ariaLabels]="ariaLabels"
  [isSingleAction]="false">
  <ng-container ngProjectAs="[actions]">
    <ul class="c-headers__list">
      <li class="c-headers__list-item">
        <maced-dropdown dropdownId="dropdownId2" name="dropdownId" ariaLabel="Dropdown" label="Select"
          cheveronClass="icon-chevron-down" [hasCheckboxesDropdown]="false" [options]="options"
          [selectedOption]="selectedOptions">
        </maced-dropdown>
      </li>
      <li class="c-headers__list-item">
        <maced-button size="large" type="link" color="primary" [url]="callToAction" buttonId="submit4"
          label="Call to Action"></maced-button>
      </li>
    </ul>
  </ng-container>
</maced-global-header>
<br>

<maced-global-header globalHeaderId="globalHeader11"  [title]="title" [logoUrl]="logoUrl" [logo]="logo"
  [smallLogo]="smallLogo" [logoAltText]="logoAltText" [moreMenuTitle]="moreMenuTitle" [ariaLabels]="ariaLabels"
  [hasReversedTitle]="true" [isSingleAction]="false" [hasHamburger]="true">
  <ng-container ngProjectAs="[actions]">
    <maced-button [ngClass]="activeMenuBar ? 'c-headers__actions-close-button' : 'c-headers__actions-hamburger-button'"
      size="large" color="secondary" [buttonId]="buttonId + 'globalHeader11'" [type]="buttonType" [name]="buttonValue"
      [label]="buttonValue" (click)="openMenu('multiButton')" [ariaExpanded]="activeMenuBar" [value]="buttonValue"
      [url]="currentUrl" [queryParams]="{ hasHamburger: activeMenuBar ? 0:1, type:'multiButton'}">Hamburger
      Menu</maced-button>
  </ng-container>
</maced-global-header>
<div *ngIf="activeMenuBar">Coming from Hamburger!</div>

<maced-global-header globalHeaderId="globalHeader12"  [title]="title" [subTitle]="subTitle" [logoUrl]="logoUrl"
  [logo]="logo" [smallLogo]="smallLogo" [logoAltText]="logoAltText" [moreMenuTitle]="moreMenuTitle"
  [ariaLabels]="ariaLabels" [hasReversedTitle]="true" [isSingleAction]="true" [hasHamburger]="true">
  <ng-container ngProjectAs="[actions]">
    <maced-button
      [ngClass]="activeHamburger ? 'c-headers__actions-close-button' : 'c-headers__actions-hamburger-button'"
      size="large" color="secondary" [buttonId]="buttonId + 'globalHeader12'" [type]="buttonType" [name]="buttonValue"
      [label]="buttonValue" (click)="openMenu('singleButton')" [ariaExpanded]="activeHamburger"
      [value]="buttonValue" [url]="currentUrl"
      [queryParams]="{ hasHamburger: activeHamburger ? 0:1, type:'singleButton'}"> </maced-button>
  </ng-container>
</maced-global-header>
<div *ngIf="activeHamburger">Coming from Hamburger!</div>
<br/>
<maced-global-header globalHeaderId="globalHeader13"  [logoUrl]="logoUrl" [logo]="logo"
  [smallLogo]="smallLogo" [logoAltText]="logoAltText" [ariaLabels]="ariaLabels"
  [hasReversedTitle]="true" [isSingleAction]="false">
  <ng-container ngProjectAs="[actions]">
    <ul class="c-headers__list">
      <li class="c-headers__list-item">
        <maced-dropdown dropdownId="dropdownId1" name="dropdownId" ariaLabel="Dropdown" label="Select"
          cheveronClass="icon-chevron-down" [hasCheckboxesDropdown]="false" [options]="options"
          [selectedOption]="selectedOptions">
        </maced-dropdown>
      </li>
      <li class="c-headers__list-item">
        <maced-button size="large" type="link" color="primary" [url]="callToAction" buttonId="submit2"
          label="Call to Action"></maced-button>
      </li>
    </ul>
  </ng-container>
</maced-global-header>
<br/>
<maced-global-header globalHeaderId="globalHeader14"  [title]="title" [subTitle]="subTitle"
  [logoUrl]="logoUrl" [logo]="logo" [smallLogo]="smallLogo" [logoAltText]="logoAltText" [moreMenuTitle]="moreMenuTitle"
  [ariaLabels]="ariaLabels" [isSingleAction]="true">
  <ng-container ngProjectAs="[actions]">
    <a class="c-header__institution-logo c-header__institution-logo--right">
      <img id="globalHeaderId+'Logo'" src="../../assets/images/logo__icon-text.svg" [alt]="logoAltText" *ngIf="logo">
    </a>
  </ng-container>
</maced-global-header>
<br/>
<maced-global-header globalHeaderId="globalHeader15"  [title]="title" [subTitle]="subTitle"
  [logoUrl]="logoUrl" [logo]="logo" [smallLogo]="smallLogo" [logoAltText]="logoAltText" [moreMenuTitle]="moreMenuTitle"
  [ariaLabels]="ariaLabels" [isSingleAction]="true">
  <ng-container ngProjectAs="[addingIcon]">
    <a class="c-header__institution-logo c-header__institution-logo--left">
      <img id="globalHeaderId+'Logo'" src="../../assets/images/logo__icon-only.svg" [alt]="logoAltText" *ngIf="logo">
    </a>
  </ng-container>
</maced-global-header>
<br/>
<maced-global-header globalHeaderId="globalHeader15"  [title]="title" [subTitle]="subTitle"
  [logoUrl]="logoUrl" [logo]="logo" [smallLogo]="smallLogo" [logoAltText]="logoAltText" [moreMenuTitle]="moreMenuTitle"
  [ariaLabels]="ariaLabels" [isSingleAction]="true" [hasMiddleIcon]="true">
  <ng-container ngProjectAs="[addingIconMiddle]">
    <a class="c-header__institution-logo c-header__institution-logo--center">
      <img id="globalHeaderId+'Logo'" src="../../assets/images/logo__text-only.svg" [alt]="logoAltText" *ngIf="logo">
    </a>
  </ng-container>
</maced-global-header>
